import React from 'react';
import { Router, Route, Link, Navigation, State } from 'react-router'

import { StickyContainer, Sticky } from 'react-sticky';

var Fluxxor = require('fluxxor');
import { FluxMixin, StoreWatchMixin, flux } from './../../flux';

import {NavigationBar}                      from './NavigationBar.jsx';
import {Header}                             from './Header.jsx';
import {ContentUpLeft}                      from './ContentUpLeft.jsx';
import {ContentRight}                       from './ContentRight.jsx';
import {ContentDownLeft}                    from './ContentDownLeft.jsx';
import {AlertPopup}                         from './AlertPopup.jsx';
import {Popup}                              from '../Popup.jsx';
import {DiffPushPopup}                      from './DiffPushPopup/index.jsx';
import {DiffPullPopup}                      from './DiffPullPopup/index.jsx';
import {PushConfirmPopup}                   from './PushConfirmPopup.jsx';
import {PullConfirmPopup}                   from './PullConfirmPopup.jsx';
import {PullByVersionPopup}                 from './PullByVersionPopup.jsx';
import {CloneByVersionPopup}                from './CloneByVersionPopup.jsx';
import {SharePackagePopup}                  from './SharePackagePopup.jsx';
import {RevokePopup}                        from './RevokePopup.jsx';
import {RejectPopup}                        from './RejectPopup.jsx';
import {RejectOffensivePopup}               from './RejectOffensivePopup.jsx';
import {SnapshotVersionPopup}               from './SnapshotVersionPopup.jsx';
import {SignUpPopup}                        from './SignUpPopup/index.jsx';
import {ForgotPassword}                     from  './SignUpPopup/ForgotPasswordPage/index.jsx';
import {ConflictErrorPopup}                 from './ConflictErrorPopup.jsx'
import {ClonePackagePopup}                  from './ClonePackagePopup.jsx';
import {CloneSuccessPopup}                  from './CloneSuccessPopup.jsx';
import {CloneWarningPopup}                  from './CloneWarningPopup.jsx';
import {ActivateUser}                       from './ActivateUser.jsx';
import {SnapshotError}                      from './SnapshotError.jsx';
import {ProvideEmailPopup}                  from './ProvideEmailPopup.jsx';
import {VerifyEmailPopup}                   from './VerifyEmailPopup.jsx';
import {wpImage}                            from '../../wpImage';
import {TransferPackagePopup}               from './TransferPackagePopup.jsx';
import {TransferRUSurePopup}                from './TransferRUSurePopup.jsx';
import {TransferSuccessPopup}               from './TransferSuccessPopup.jsx';
import {TransferRevokePopup}                from './TransferRevokePopup.jsx';
import {TransferWarningDependenciesPopup}   from './TransferWarningDependenciesPopup.jsx';
import {UpdatePackagePopup}                 from './UpdatePackagePopup.jsx';


var DetailsPage = React.createClass({
	mixins: [wpImage, FluxMixin, StoreWatchMixin("MainStore")],
      getStateFromFlux: function() {
          var flux = this.getFlux();
                return {
                            data                    : flux.store("MainStore").detailData,
							dependency              : flux.store("MainStore").dependency,
                            active                  : flux.store("MainStore").activeTheme,
                            errors                  : flux.store("MainStore").errors,
                            errors1                 : flux.store("MainStore").errors1,
                            updatesData             : flux.store("MainStore").updatesData,
                            aquisitions             : flux.store("MainStore").aquisitions,
                            pullDiffData            : flux.store("MainStore").pullDiffData,
                            pullConfirmPopup        : flux.store("MainStore").pullConfirmPopup,
                            pushConfirmPopup        : flux.store("MainStore").pushConfirmPopup,
                            pushDiffData            : flux.store("MainStore").pushDiffData,
                            pullVersionPopup        : flux.store("MainStore").pullVersionPopup,
                            cloneVersionPopup       : flux.store("MainStore").cloneVersionPopup,
                            clonePackagePopup       : flux.store("MainStore").clonePackagePopup,
                            sharePackagePopup       : flux.store("MainStore").sharePackagePopup,
                            revokePopup             : flux.store("MainStore").revokePopup,
                            rejectPopup             : flux.store("MainStore").rejectPopup,
                            rejectOffensivePopup    : flux.store("MainStore").rejectOffensivePopup,
                            snapshotVersionPopup    : flux.store("MainStore").snapshotVersionPopup,
                            signUpPopup             : flux.store("MainStore").signUpPopup,
                            activeUserError         : flux.store("MainStore").activeUserError,
                            activateUser            : flux.store("MainStore").activateUser,
                            conflictErrorPopup      : flux.store("MainStore").conflictErrorPopup,
                            signInData              : flux.store("MainStore").signInData,
                            cloneSuccessPopup       : flux.store("MainStore").cloneSuccessPopup,
                            cloneWarningPopup       : flux.store("MainStore").cloneWarningPopup,
                            forgotPasswordPopup     : flux.store("MainStore").forgotPasswordPopup,
                            snapshotErrorPopup      : flux.store("MainStore").snapshotErrorPopup,
                            provideEmailPopup       : flux.store("MainStore").provideEmailPopup,
                            verifyEmailPopup        : flux.store("MainStore").verifyEmailPopup,
                            accountsList            : flux.store("MainStore").accountsList,
                            transferPackagePopup    : flux.store("MainStore").transferPackagePopup,
                            transferRUSurePopup     : flux.store("MainStore").transferRUSurePopup,
                            transferSuccessPopup    : flux.store("MainStore").transferSuccessPopup,
                            transferRevokePopup     : flux.store("MainStore").transferRevokePopup,
                            transferWarningDependenciesPopup : flux.store("MainStore").transferWarningDependenciesPopup,
                            updatePackagePopup      : flux.store("MainStore").updatePackagePopup
                        }
    },
    componentDidMount : function () {
        this.getFlux().actions.hostUrl = this.props.platform.hostUrl;

        this.setState({slug: this.props.location.query.val});  // retrieve the value of slug from the query in url and set it in variable slug.
        this.setState({account: this.props.location.query.account});
        this.setState({library: this.props.location.query.lib});  // retrieve the value of library from the query in url and set in variable library.
        this.setState({"type": this.props.location.query.type})
        this.getFlux().actions.getActiveTheme();
        this.getFlux().actions.getDetailData(this.props.location.query.account, this.props.location.query.val); // calls an action passes slug as paramerter.
        this.getFlux().actions.getUpdates();
        
        //this.getFlux().actions.getLicenses(this.props.location.query.val);
        window.addEventListener("hashchange", this.onHashChange);

    },
    componentWillUnmount: function(){
        window.removeEventListener("hashchange", this.onHashChange);
    },
    onHashChange: function (){
        sessionStorage.setItem("lib", this.state.library); // back button previous state list/grid page
    },
    getInitialState: function(){
        return {slug: null,
                account: "",
                library: "",
                showPopup: false,
                activeName: "",
                action: "",
                "type": null }
    },
    accountSlug: function(){
        return this.state.data.hasOwnProperty("name") ? this.state.data["name"].split("/")[0].toLowerCase() : this.props.location.query.account;
    },
    slug: function(){
        return this.state.data.hasOwnProperty("name") ? this.state.data["name"].split("/")[1].toLowerCase() : this.props.location.query.val;
    },
    buyLib: function(dependencies,slug){
        this.getFlux().actions.buyLib(dependencies,slug);  // calls actions when user click on Buy.
    },
    addToCart: function(dependencies,slug){
        this.getFlux().actions.addToCart(dependencies, slug);   // calls actions when user click on Add To Cart.
    },
    clone: function(action, newThemeName, newPackageName){
        var name = this.state.data["name"].split("/");
        this.getFlux().actions.clone(action, name[0], name[1], newThemeName, newPackageName);
    },
    alertPopup: function(){
        this.getFlux().actions.closeAlertPopup();
    },
    showPreview: function(){
        this.getFlux().actions.showPreview(this.state.data["user"], this.state.data["slug"]);
    },
    editTheme: function(slug, accountSlug){
        this.getFlux().actions.editTheme(slug, accountSlug, this.state.data.type);
    },
    openSource: function(){
        this.getFlux().actions.openSource(this.state.data["user"], this.state.data["slug"]);
    },
    makeActive: function(slug){
        this.getFlux().actions.makeActive(slug);
    },
    pull: function (slug) {
        this.getFlux().actions.pull(slug)
    },
    push: function (slug){
        this.getFlux().actions.push (slug);
    },
    pushDiff: function (flag, files){
        var accountSlug = this.state.data["user"];
        if(localStorage.getItem("session_key") !== null && this.state.data["user"] == "anonymous"){
            accountSlug = this.state.signInData["slug"];
        }
        this.getFlux().actions.pushDiff(flag, accountSlug, this.state.data["slug"], files, this.state.pushDiffData.packageHash);
    },
    pullDiff: function(flag, files){
        var accountSlug = this.state.data["user"];
        if(localStorage.getItem("session_key") !== null && this.state.data["user"] == "anonymous"){
            accountSlug = this.state.signInData["slug"];
        }
        this.getFlux().actions.pullDiff(flag, accountSlug, this.state.data["slug"], files);
    },
    install: function(slug, label){
        this.getFlux().actions.install(slug, label);
    },
    viewDependencies: function(){
        this.getFlux().actions.getDependecies(this.props.location.query.val);
    },
    popup: function(value, action){
        this.setState({ showPopup: !this.state.showPopup, 
                        activeName: value, 
                        action: action });
    },
    version: function(label){
        if(this.state.action === "pull"){
            this.pull(this.state.activeName, label)
        }else if(this.state.action === "install"){
            this.install(this.state.activeName, label)
        } else {
            this.makeActive(this.state.activeName, label);
        }
    },
    confirmPush: function(action){
        var data = this.state.pushConfirmPopup.data;
        var accountSlug = this.state.data["user"];
        if(localStorage.getItem("session_key") !== null && this.state.data["user"] == "anonymous"){
            accountSlug = this.state.signInData["slug"];
        }
        this.getFlux().actions.confirmPush(action, accountSlug, this.state.data["slug"], data, this.state.pushConfirmPopup.packageHash);
    },
    confirmPull: function(action){
        var data = this.state.pullConfirmPopup.data;
        var accountSlug = this.state.data["user"];
        if(localStorage.getItem("session_key") !== null && this.state.data["user"] == "anonymous"){
            accountSlug = this.state.signInData["slug"];
        }
        this.getFlux().actions.confirmPull(action, accountSlug, this.state.data["slug"],  data);
    },
    pullByVersion: function(bool, version){
        this.getFlux().actions.pullByVersion(bool, this.state.slug, version);
    },
    cloneByVersion: function(version){
        this.getFlux().actions.cloneByVersion(this.state.slug, version);
    },
    cloneByVersionPopup: function(bool){
        this.getFlux().actions.cloneByVersionPopup(bool);
    },
    sharePackage: function(action, data = null, message = null){
        this.getFlux().actions.sharePackage(action, this.accountSlug(), this.slug(), data, message);
    },
    revoke: function(action, revokeId){
        this.getFlux().actions.revoke(action, revokeId, this.accountSlug(), this.slug());
    },
    reject: function(action, data){
        this.getFlux().actions.reject(action, data, this.accountSlug(), this.slug());
    },
    rejectOffensive: function(action, data){
        this.getFlux().actions.rejectOffensive(action, data, this.accountSlug(), this.slug());
    },
    snapshot: function(action, version, data = null){
      let accountSlug = this.state.data["name"].split("/")[0];
      let slug = this.state.data["name"].split("/")[1];
      let package_name = accountSlug + "/" + slug;
      this.getFlux().actions.snapshot(action, version, package_name, data);
    },
    snapshotError: function(action){
      this.getFlux().actions.snapshotError(action);
    },
    makeCanonicalSnapshot: function(label, data){
        let accountSlug = this.state.data["name"].split("/")[0];
        let slug = this.state.data["name"].split("/")[1];
        let package_name = accountSlug + "/" + slug;
        this.getFlux().actions.makeCanonicalSnapshot(label, accountSlug, slug, data)        
    },
    handleDeleteClick: function(){
        alert("Coming soon")
    },
    conflictError: function(action){
        this.getFlux().actions.conflictError(action);
    },
    cloneSuccess: function(action){
        this.getFlux().actions.cloneSuccess(action, this.state.cloneSuccessPopup.accountSlug, this.state.cloneSuccessPopup.newSlug);        
    },
    cloneWarning: function(action){
        this.getFlux().actions.cloneWarning(action);
    },
    provideEmail: function(action, email) {
        this.getFlux().actions.provideEmail(action, this.accountSlug(), this.slug(), email);
    },
    verifyEmail: function(action, email) {
        this.getFlux().actions.verifyEmail(action, this.accountSlug(), this.slug(), email);  
    },
    searchAccounts: function(value){
        this.getFlux().actions.searchAccounts(value);    
    },
    resendInvite: function(body){
        this.getFlux().actions.resendInvite (this.accountSlug(), this.slug(), body);  
    },
    transferPackage: function(action, receiver){
        this.getFlux().actions.transferPackage(action, this.accountSlug(), this.slug(), receiver);
    },
    transferRUSure: function(action, receiver) {
        this.getFlux().actions.transferRUSure(action, this.accountSlug(), this.slug(), receiver);
    },
    transferSuccess: function(action){
        this.getFlux().actions.transferSuccess(action, this.accountSlug(), this.slug()); 
    },
    transferRevoke: function(action){
        this.getFlux().actions.transferRevoke(action, this.accountSlug(), this.slug());   
    },
    transferWarningDependencies: function(action) {
        this.getFlux().actions.transferWarningDependencies(action, this.accountSlug(), this.slug());
    },
    updatePackage: function(action){
        this.getFlux().actions.updatePackage(action, this.accountSlug(), this.slug());
    },  
    render: function(){
        var platform = this.props.platform;
        var marginTop  = "0px";
        // if(window.location.href.indexOf("admin") > -1){
        //     marginTop = "32px"
        // }
        marginTop = platform.css.marginTop;
        return(
            <StickyContainer>
                <link rel="stylesheet" href={platform.style}/>
                <div className="container">
                   <NavigationBar   libName = {this.state.library} 
                                    themeName = {this.props.location.query.val} />
                    <section className="content-section">
                        <Sticky style={{transform: "translateZ(90)", marginTop: marginTop}}>
                            <header>
            	                <Header data = {this.state.data}
                                        clone = {this.clone}
                                        sharePackage = {this.sharePackage}
                                        transferPackage = {this.transferPackage}
                                        snapshot = {this.snapshot}
                                        editTheme = {this.editTheme}
                                        showPreview = {this.showPreview}
                                        openSource = {this.openSource}
                                        makeActive = {this.makeActive}
                						slug =  {this.props.location.query.val}
                						pull =  {this.pull}
                                        push = {this.push}  
                                        install = {this.install}
                                        active = {this.state.active} 
                                        themeName = {this.state.data["slug"]}
                                        popup = {this.popup}
                                        val = {this.props.location.query.val}
                                        aquisitions = {this.state.aquisitions}
                                        cloneByVersionPopup = {this.cloneByVersionPopup}
                                        pullByVersion = {this.pullByVersion}
                                        librar = {this.state.data.type}
                                        libName = {this.state.library}
                                        account = {this.props.location.query.account}
                                        type = {this.state.type}
                                        updatePackage = {this.updatePackage} />
                            </header>
                        </Sticky>
    	              <div className="content-container">
    	                <div className="content-container__inner">
                            <div className="two_thirds-lg left-container">
    	                        <ContentUpLeft  data = {this.state.data}/>
    	                        <ContentRight   data = {this.state.data}
    											dependency = {this.state.dependency}
                                                addToCart = {this.addToCart}
                                                buyLib = {this.buyLib}
                                                viewDependencies = {this.viewDependencies} />
    	                        <ContentDownLeft data = {this.state.data} />
    	                    </div>
    	                </div>
                      </div>

                      {this.state.library === "Shared with me" ?
                        <div className="btn-container">
                            <button className="btn__md bg-bold" onClick = {this.reject.bind(this, "open", null)}>Reject</button>
                        </div> : 
                        <div className="btn-container">
                            <button className="btn__md bg-bold" onClick = {this.handleDeleteClick}>Delete</button>
                        </div> 
                      }

    	            </section>

                    {this.state.transferPackagePopup.popup ?
                    <TransferPackagePopup   transferPackage = {this.transferPackage}
                                            slug = {this.slug()}
                                            accountsList = {this.state.accountsList}
                                            searchAccounts = {this.searchAccounts} /> : null }

                    { this.state.transferRUSurePopup.popup ?
                    <TransferRUSurePopup    transferRUSure = {this.transferRUSure}
                                            data = {this.state.transferRUSurePopup.data}
                                            slug = {this.slug()} /> : null }

                    {this.state.transferSuccessPopup.popup ?
                    <TransferSuccessPopup   transferSuccess = {this.transferSuccess}
                                            slug = {this.slug()}
                                            receiver = {this.state.transferSuccessPopup.data} /> : null }

                    {this.state.transferRevokePopup.popup ?
                    <TransferRevokePopup transferRevoke = {this.transferRevoke} /> : null }

                    {this.state.transferWarningDependenciesPopup.popup ?
                    <TransferWarningDependenciesPopup transferWarningDependencies = {this.transferWarningDependencies}
                                                      data = {this.state.transferWarningDependenciesPopup.data} /> : null }
                    
                    {this.state.clonePackagePopup.popup ?
                    <ClonePackagePopup  clone = {this.clone}
                                        slug = {this.state.data["name"].split("/")[1]}
                                        user = {this.state.data["name"].split("/")[0]}
                                        errors = {this.state.errors}
                                        closeAlertPopup = {this.alertPopup} /> : null }

                    {this.state.snapshotVersionPopup.popup ?
                    <SnapshotVersionPopup snapshot = {this.snapshot}
                                          data = {this.state.snapshotVersionPopup.data}
                                          makeCanonicalSnapshot = {this.makeCanonicalSnapshot}
                                          themeName = {this.state.slug}
                                          errors = {this.state.errors} /> : null }

                    {this.state.sharePackagePopup.popup ? 
                    <SharePackagePopup  sharePackage = {this.sharePackage}
                                        revoke = {this.revoke}
                                        themeName = {this.slug()}
                                        data = {this.state.sharePackagePopup.data}
                                        revokePopup = {this.state.revokePopup}
                                        accountsList = {this.state.accountsList}
                                        searchAccounts = {this.searchAccounts}
                                        resendInvite = {this.resendInvite} /> : null }

                    {this.state.provideEmailPopup.popup ?
                    <ProvideEmailPopup provideEmail = {this.provideEmail}/> : null }

                    {this.state.verifyEmailPopup.popup ?
                    <VerifyEmailPopup verifyEmail = {this.verifyEmail}/> : null }

                    {this.state.updatePackagePopup.popup ?
                    <UpdatePackagePopup updatePackage = {this.updatePackage}
                                        slug = {this.slug()}
                                        data = {this.state.updatePackagePopup.data} /> : null }

                    {this.state.rejectPopup.popup ?
                    <RejectPopup reject = {this.reject} 
                                 rejectOffensive = {this.rejectOffensive}
                                 data = {this.state.rejectPopup.data}  /> : null }

                    {this.state.rejectOffensivePopup.popup ?
                    <RejectOffensivePopup   rejectOffensive = {this.rejectOffensive}
                                            data = {this.state.rejectOffensivePopup.data}
                                            reject = {this.reject} /> : null }
                    
                    {this.state.errors.popup ?
                    <AlertPopup  alertPopup= {this.alertPopup} 
                                 errors = {this.state.errors} /> : null }

                    {this.state.errors1.popup ?
                    <AlertPopup  alertPopup= {this.alertPopup} 
                                 errors = {this.state.errors1} /> : null }

                    {this.state.showPopup ? 
                    <Popup popup = {this.popup}
                           version = {this.version} /> : null }

                    {this.state.pushDiffData.popup ?
                    <DiffPushPopup  push = {this.push}
                                    pushDiff = {this.pushDiff}
                                    pushDiffData = {this.state.pushDiffData.data} /> : null}

                    {this.state.pullDiffData.popup ?
                    <DiffPullPopup  pull = {this.pull}
                                    pullDiff = {this.pullDiff}
                                    pullDiffClose = {this.pullDiffClose}
                                    pullDiffData = {this.state.pullDiffData.data} /> : null}

                    {this.state.pushConfirmPopup.popup ?
                    <PushConfirmPopup   confirmPush = {this.confirmPush}
                                        data = {this.state.pushConfirmPopup.data} /> : null}
                    
                     {this.state.pullConfirmPopup.popup ?
                    <PullConfirmPopup   confirmPull = {this.confirmPull}
                                        data = {this.state.pullConfirmPopup.data}  /> : null}

                    {this.state.pullVersionPopup.popup ?
                    <PullByVersionPopup pullByVersion = {this.pullByVersion}
                                        data = {this.state.pullVersionPopup.data} /> : null }

                    {this.state.cloneVersionPopup ?
                    <CloneByVersionPopup    cloneByVersion = {this.cloneByVersion}
                                            cloneByVersionPopup = {this.cloneByVersionPopup} /> : null }

                    {this.state.revokePopup.popup ?
                    <RevokePopup revoke = {this.revoke}
                                 revokeId = {this.state.revokePopup.revokeId}
                                 themeName = {this.slug()} /> : null }

                    {this.state.snapshotErrorPopup.popup ?
                    <SnapshotError slug = {this.props.location.query.val}
                                   snapshotError = {this.snapshotError} /> : null }

                    {this.state.signUpPopup.popup ?
                    <SignUpPopup /> : null }

                    {this.state.activateUser.popup ?
                    <ActivateUser /> : null }

                    {this.state.conflictErrorPopup.popup ?
                    <ConflictErrorPopup conflictError = {this.conflictError}
                                        slug = {this.props.location.query.val} /> : null }

                    {this.state.cloneSuccessPopup.popup ?
                    <CloneSuccessPopup  cloneSuccess = {this.cloneSuccess} 
                                        themeName = {this.state.data["slug"]}
                                        cloneSuccessPopup = {this.state.cloneSuccessPopup} 
                                        libName = {this.state.library} /> : null }

                    {this.state.cloneWarningPopup.popup ?
                    <CloneWarningPopup cloneWarning = {this.cloneWarning}
                                       slug = {this.state.cloneWarningPopup.slug} /> : null }

                    {this.state.forgotPasswordPopup.popup ?
                    <ForgotPassword /> : null }

    	        </div>
            </StickyContainer>
	    );
  	}
});

export {DetailsPage};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/index.jsx
 **/